import { CheckCircle } from '@mui/icons-material';
import { Divider, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import GradientAiIcon from 'components/icons/GradientAiIcon';
import { Row } from 'further-ui/components/Layout';

const ToastCard = styled('div')({
  position: 'fixed',
  top: 72,
  right: 24,
  width: 300,
  zIndex: 1400,
  background: 'rgba(255, 255, 255, 0.95)',
  backdropFilter: 'blur(20px)',
  borderRadius: 16,
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
  overflow: 'hidden',
  pointerEvents: 'none',
});

const ToastHeader = styled(Row)(({ theme }) => ({
  padding: theme.spacing(3, 4),
}));

const ToastBody = styled(Row)(({ theme }) => ({
  padding: theme.spacing(3, 4),
}));

type Props = { message: string };

const AgentToast = ({ message }: Props) => (
  <ToastCard>
    <ToastHeader centered spacing="xs">
      <GradientAiIcon size={16} />
      <Typography variant="subtitle2">AI Agent</Typography>
    </ToastHeader>
    <Divider />
    <ToastBody centered spacing="sm">
      <CheckCircle
        sx={{ color: 'success.main', fontSize: 20, flexShrink: 0 }}
      />
      <Typography variant="body2" color="text.primary">
        {message}
      </Typography>
    </ToastBody>
  </ToastCard>
);

export default AgentToast;
